import { OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ClientService } from 'app/services/client-service';
import { ToastrService } from 'ngx-toastr';
import { CommonsUtils } from 'app/commons/CommonsUtils';
import { AuthService } from 'app/security/auth.service';
import { CommonsText } from 'app/commons/CommonsText';
import { CustomDateValidator } from 'app/commons/custom-date-validator';
var ProfileContactEditionComponent = /** @class */ (function () {
    function ProfileContactEditionComponent(formBuilder, clientService, toastr, authService) {
        this.formBuilder = formBuilder;
        this.clientService = clientService;
        this.toastr = toastr;
        this.authService = authService;
        this.profileAction = new EventEmitter();
        this.actualPostalCode = '00000';
        this.messages = null;
        this.running = false;
        this.loading = false;
        this.loadingCities = false;
        this.patching = false;
        this.contactProgress = 0;
        this.addressProgress = 0;
        this.roadTypeList = [];
        this.cityList = [];
        this.isCompany = false;
        this.CODE_ERROR_EMAIL_ALREADY_REGISTERED = 'email.already_registered';
        this.ERROREMAILACONT = 'ERROREMAILACONT';
        this.ERRORMOBILECONT = 'ERRORMOBILECONT';
        this.ERRORPHONECONT = 'ERRORPHONECONT';
        this.prefijoPhoneFlag = null;
        this.prefijoFijoPhoneFlag = null;
        /**
         * Teléfono y prefijo van siempre juntos: el backend los concatena como "+<prefijo> <número>"
         * (ModifyClientCoreCmd), así que un número sin prefijo se guardaría como "+null 666999888" y
         * un prefijo suelto como "+34 null".
         */
        this.PHONE_PAIRS = [
            { phone: 'phone', prefix: 'phonePrefix' },
            { phone: 'mobilePhone', prefix: 'mobilePhonePrefix' }
        ];
        this.prefixData = CommonsUtils.phonePrefix();
        this.prefixSettings = {
            singleSelection: true,
            text: 'Prefijo',
            enableCheckAll: false,
            enableSearchFilter: true,
            enableFilterSelectAll: false,
            searchPlaceholderText: 'Filtro',
            showCheckbox: true,
            classes: 'multi-select-phone',
            clearAll: false
        };
    }
    ProfileContactEditionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setMaxDate();
        if (this.authService.isLogged()) {
            var user = this.authService.getUser();
            this.isCompany = !!(user.documentType && user.documentType === 'CIF');
        }
        this.contactFactor = this.clientService.getContactFactor();
        this.addressFactor = this.clientService.getAddressFactor();
        this.roadTypeSettings = {
            singleSelection: true,
            text: 'Tipo de vía',
            enableCheckAll: false,
            enableSearchFilter: true,
            enableFilterSelectAll: false,
            searchPlaceholderText: 'Filtro',
            classes: 'multi-select',
            clearAll: false
        };
        this.citySettings = {
            singleSelection: true,
            text: 'Introduzca un código postal y seleccione una población',
            enableCheckAll: false,
            enableSearchFilter: true,
            enableFilterSelectAll: false,
            searchPlaceholderText: 'Filtro',
            classes: 'multi-select',
            clearAll: false
        };
        this.contactForm = this.formBuilder.group({
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            lastName: ['', []],
            birthDate: ['', this.isCompany ? [] : [Validators.required, Validators.minLength(10), CustomDateValidator.minAge, CustomDateValidator.maxAge]],
            phonePrefix: ['', []],
            phone: ['', [CommonsUtils.validPhone('phonePrefix')]],
            mobilePhonePrefix: ['', [Validators.required]],
            mobilePhone: ['', [Validators.required, CommonsUtils.validMobilePhone('mobilePhonePrefix')]],
            email: ['', [Validators.required, Validators.email, Validators.pattern(CommonsUtils.EMAIL_REGEX)]],
            province: ['', []],
            postalCode: ['', [Validators.required]],
            cityCb: ['', [Validators.required]],
            roadType: ['', [Validators.required]],
            address: ['', [Validators.required]],
            number: ['', [Validators.required]],
            portal: ['', []],
            stair: ['', []],
            floor: ['', []],
            door: ['', []],
            notificationChannel: ['', []]
        });
        this.contactForm.valueChanges.subscribe(function () {
            if (!_this.patching) {
                _this.checkContactPercent();
                _this.checkAddressPercent();
            }
            _this.messages = null;
        });
        this.loadData();
    };
    ProfileContactEditionComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        Promise.all([
            this.clientService.getClient(),
            this.clientService.getRoadTypes()
        ]).then(function (_a) {
            var client = _a[0], roadTypesResponse = _a[1];
            _this.loading = false;
            _this.roadTypeList = roadTypesResponse.response;
            _this.patchForm(client);
        }).catch(function () {
            _this.loading = false;
            _this.toastr.error(CommonsText.PROBLEMA_DE_CONECTIVIDAD, CommonsText.PROBLEMA_DE_CONECTIVIDAD, { timeOut: 5000 });
        });
    };
    ProfileContactEditionComponent.prototype.patchForm = function (value) {
        if (!value) {
            return;
        }
        this.patching = true;
        this.contactForm.patchValue({ name: this.parseValue(value.name) });
        this.contactForm.patchValue({ surname: this.parseValue(value.surname) });
        this.contactForm.patchValue({ lastName: this.parseValue(value.lastName) });
        this.contactForm.patchValue({
            birthDate: value.birthDate ? this.parseValue(value.birthDate.replace(/\//g, '-')) : null
        });
        this.contactForm.patchValue({ email: this.parseValue(value.email) });
        this.contactForm.patchValue({ phone: this.parseValue(value.phone) });
        this.contactForm.patchValue({ phonePrefix: this.parsePairedPrefixValue(value.phone, value.phonePrefix) });
        this.contactForm.patchValue({ mobilePhone: this.parseValue(value.mobilePhone) });
        this.contactForm.patchValue({
            mobilePhonePrefix: this.parsePairedPrefixValue(value.mobilePhone, value.mobilePhonePrefix)
        });
        this.contactForm.patchValue({ address: this.parseValue(value.address) });
        this.contactForm.patchValue({ province: this.parseValue(value.province) });
        this.province = this.parseValue(value.province);
        this.contactForm.patchValue({ postalCode: this.parseValue(value.postalCode) });
        this.contactForm.patchValue({ cityCb: this.parseCityValue(value) });
        this.contactForm.patchValue({ roadType: this.parseSelectValue(value.roadType) });
        this.contactForm.patchValue({ number: this.parseValue(value.number) });
        this.contactForm.patchValue({ portal: this.parseValue(value.portal) });
        this.contactForm.patchValue({ stair: this.parseValue(value.stair) });
        this.contactForm.patchValue({ floor: this.parseValue(value.floor) });
        this.contactForm.patchValue({ door: this.parseValue(value.door) });
        this.contactForm.patchValue({ notificationChannel: this.parseValueRadioButton(value.notifications) });
        this.patching = false;
        this.documentType = value.documentType;
        this.documentNumber = value.documentNumber;
        this.contactProgress = this.clientService.getContactPercent(value);
        this.addressProgress = this.clientService.getAddressPercent(value);
    };
    ProfileContactEditionComponent.prototype.onSave = function () {
        var _this = this;
        this.messages = [];
        if (this.running) {
            return;
        }
        // Se comprueba al enviar, no mientras se teclea: al rellenar el número el prefijo aún
        // está vacío y no tiene sentido avisar de ello hasta que se da por terminado el formulario.
        this.validatePhonePairs();
        if (this.contactForm.valid) {
            this.running = true;
            this.changeFormatBirthDate();
            this.clientService.onModifyContact(this.contactForm.value)
                .then(function () {
                _this.running = false;
                _this.toastr.success(CommonsText.PERFIL_ACTUALIZADO_EXITO, CommonsText.OPERACION_COMPLETADA, { timeOut: 5000 });
                _this.profileAction.emit({ section: 'profile' });
            })
                .catch(function (error) {
                _this.running = false;
                _this.handleSaveError(error);
            });
        }
        else {
            Object.keys(this.contactForm.controls).forEach(function (field) {
                _this.contactForm.get(field).markAsTouched({ onlySelf: true });
            });
            this.contactForm.controls['cityCb'].markAsTouched({ onlySelf: true });
        }
    };
    ProfileContactEditionComponent.prototype.onCancel = function () {
        this.profileAction.emit({ section: 'profile' });
    };
    ProfileContactEditionComponent.prototype.handleSaveError = function (error) {
        var devResponse = error.error && error.error.developerResponse;
        if (devResponse === this.CODE_ERROR_EMAIL_ALREADY_REGISTERED) {
            this.messages = ['Este correo electrónico ya está en uso.'];
            this.contactForm.get('email').setErrors({ incorrect: true });
            this.toastr.error(error.response, CommonsText.ERROR_OPERACION_CORREO_EN_USO, { timeOut: 5000 });
        }
        else {
            this.messages = (error.error && error.error.response) ? error.error.response : [CommonsText.PROBLEMA_DE_CONECTIVIDAD];
            if (error.error && error.error.response) {
                if (devResponse === this.ERROREMAILACONT) {
                    this.contactForm.get('email').setErrors({ incorrect: true });
                    this.contactForm.get('email').markAsTouched({ onlySelf: true });
                }
                if (devResponse === this.ERRORMOBILECONT) {
                    this.contactForm.get('mobilePhone').setErrors({ incorrect: true });
                    this.contactForm.get('mobilePhone').markAsTouched({ onlySelf: true });
                }
                if (devResponse === this.ERRORPHONECONT) {
                    this.contactForm.get('phone').setErrors({ incorrect: true });
                    this.contactForm.get('phone').markAsTouched({ onlySelf: true });
                }
                this.toastr.error(error.error.response, CommonsText.ERROR_DE_OPERACION, { timeOut: 5000 });
            }
        }
    };
    ProfileContactEditionComponent.prototype.setMaxDate = function () {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        this.maxDate = date;
    };
    ProfileContactEditionComponent.prototype.changeFormatBirthDate = function () {
        if (this.isCompany) {
            this.contactForm.value.birthDate = null;
        }
        else if (this.contactForm.value.birthDate) {
            if (this.contactForm.value.birthDate instanceof Date) {
                var d = this.contactForm.value.birthDate;
                this.contactForm.value.birthDate =
                    this.addLeadingZero(d.getDate()) + "-" + this.addLeadingZero(d.getMonth() + 1) + "-" + d.getFullYear();
            }
            else {
                // Formato con guiones (dd-mm-aaaa), como el resto de la app; el servicio
                // lo convierte a barras al enviarlo al backend.
                this.contactForm.value.birthDate = this.contactForm.value.birthDate.replace(/\//g, '-');
            }
        }
    };
    ProfileContactEditionComponent.prototype.addLeadingZero = function (value) {
        return value < 10 ? "0" + value : "" + value;
    };
    ProfileContactEditionComponent.prototype.checkContactPercent = function () {
        var _this = this;
        this.contactProgress = 100;
        ['name', 'surname', 'email', 'mobilePhone', 'birthDate'].forEach(function (ctrl) {
            if (_this.contactForm.controls[ctrl].invalid) {
                _this.contactProgress -= _this.contactFactor;
            }
        });
    };
    ProfileContactEditionComponent.prototype.checkAddressPercent = function () {
        var _this = this;
        this.addressProgress = 100;
        ['postalCode', 'cityCb', 'roadType', 'address', 'number'].forEach(function (ctrl) {
            if (_this.contactForm.controls[ctrl].invalid) {
                _this.addressProgress -= _this.addressFactor;
            }
        });
    };
    ProfileContactEditionComponent.prototype.searchCity = function () {
        var _this = this;
        var postalCode = this.contactForm.controls['postalCode'].value;
        if (postalCode && postalCode.length === 5 && !this.loadingCities) {
            this.loadingCities = true;
            this.clientService.onSearchCity(postalCode)
                .then(function (success) {
                _this.actualPostalCode = postalCode;
                _this.loadingCities = false;
                _this.cityList = [];
                _this.contactForm.controls['cityCb'].patchValue(null);
                for (var _i = 0, _a = success.response; _i < _a.length; _i++) {
                    var city = _a[_i];
                    _this.cityList.push({ id: city.id, itemName: city.name, province: city.province });
                }
                if (success.response.length === 1) {
                    var city = success.response[0];
                    _this.contactForm.patchValue({ cityCb: [{ id: city.id, itemName: city.name, province: city.province }] });
                    _this.contactForm.patchValue({ province: _this.parseValue(city.province) });
                    _this.province = _this.parseValue(city.province);
                }
            })
                .catch(function (error) {
                _this.loadingCities = false;
                _this.toastr.error(error.response, CommonsText.ERROR_DE_OPERACION, { timeOut: 5000 });
            });
        }
    };
    ProfileContactEditionComponent.prototype.onChangePostalCode = function (data) {
        var v = data.target.value;
        if (v.length === 5 && v !== this.actualPostalCode) {
            this.searchCity();
        }
    };
    ProfileContactEditionComponent.prototype.onCitySelect = function (item) {
        this.province = this.parseValue(item.province);
        this.contactForm.patchValue({ province: this.parseValue(item.province) });
    };
    ProfileContactEditionComponent.prototype.isInvalid = function (controlName) {
        var control = this.contactForm.controls[controlName];
        return control.invalid && (control.touched || control.dirty);
    };
    ProfileContactEditionComponent.prototype.hasError = function (controlName, errorKey) {
        var control = this.contactForm.controls[controlName];
        return !!control && control.hasError(errorKey);
    };
    /**
     * Cada pareja teléfono/prefijo ha de informarse entera o dejarse entera en blanco. Marca en
     * el prefijo el error que corresponda, de forma que el formulario quede inválido y no se
     * llegue a enviar.
     */
    ProfileContactEditionComponent.prototype.validatePhonePairs = function () {
        var _this = this;
        this.PHONE_PAIRS.forEach(function (pair) {
            var phoneControl = _this.contactForm.get(pair.phone);
            var prefixControl = _this.contactForm.get(pair.prefix);
            var phoneValue = phoneControl.value;
            var hasPhone = (null !== phoneValue) && (undefined !== phoneValue)
                && ('' !== String(phoneValue).trim());
            // El prefijo es un multiselect: su valor es un array con el único elemento elegido.
            var prefixValue = prefixControl.value;
            var hasPrefix = !!prefixValue && (prefixValue.length > 0);
            _this.setPairError(prefixControl, 'prefixRequired', hasPhone && !hasPrefix);
            _this.setPairError(prefixControl, 'prefixNotAllowed', !hasPhone && hasPrefix);
            if (prefixControl.invalid) {
                prefixControl.markAsTouched({ onlySelf: true });
            }
        });
    };
    /**
     * Añade o quita una clave de error sin pisar las de los validadores del control, que
     * setErrors reemplaza por completo.
     */
    ProfileContactEditionComponent.prototype.setPairError = function (control, errorKey, active) {
        var errors = control.errors || {};
        if (active) {
            errors[errorKey] = true;
        }
        else {
            delete errors[errorKey];
        }
        control.setErrors(Object.keys(errors).length > 0 ? errors : null);
    };
    ProfileContactEditionComponent.prototype.cambioPrefijo = function (controlName, event) {
        if (controlName === 'phone' && event.length > 0 && event[0].id !== this.prefijoFijoPhoneFlag) {
            var val = this.contactForm.get(controlName).value;
            this.contactForm.get(controlName).setErrors(null);
            this.prefijoFijoPhoneFlag = this.contactForm.get('phonePrefix').value[0].id;
            this.contactForm.get(controlName).setValue(null);
            this.contactForm.get(controlName).setValue(val);
        }
        if (controlName === 'mobilePhone' && event.length > 0 && event[0].id !== this.prefijoPhoneFlag) {
            var val = this.contactForm.get(controlName).value;
            this.contactForm.get(controlName).setErrors(null);
            this.prefijoPhoneFlag = this.contactForm.get('mobilePhonePrefix').value[0].id;
            this.contactForm.get(controlName).setValue(null);
            this.contactForm.get(controlName).setValue(val);
        }
    };
    ProfileContactEditionComponent.prototype.getButtonLabel = function () {
        return this.running ? CommonsText.CARGANDO : CommonsText.GUARDAR_CAMBIOS_MINUSCULA;
    };
    ProfileContactEditionComponent.prototype.parseValue = function (value) {
        if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
            return null;
        }
        return value;
    };
    ProfileContactEditionComponent.prototype.parseSelectValue = function (value) {
        return (value !== null && value !== undefined) ? value : [];
    };
    /**
     * El backend siempre devuelve prefijo, incluso sin teléfono: CommonUtils.getPrefix() cae en
     * "34" por defecto. Cargarlo tal cual dejaría el formulario con un prefijo suelto y el aviso
     * de "prefijo sin teléfono" saltaría nada más guardar a quien no tenga fijo, así que el
     * prefijo solo se precarga si hay número al que acompañar.
     */
    ProfileContactEditionComponent.prototype.parsePairedPrefixValue = function (phone, prefix) {
        var hasPhone = (null !== phone) && (undefined !== phone) && ('' !== String(phone).trim());
        return hasPhone ? this.parsePrefixValue(prefix) : null;
    };
    ProfileContactEditionComponent.prototype.parsePrefixValue = function (value) {
        if (value === null || value === undefined) {
            return null;
        }
        var prefix;
        this.prefixData.forEach(function (n) { if (n.id === value) {
            prefix = n;
        } });
        return prefix !== undefined ? [prefix] : null;
    };
    ProfileContactEditionComponent.prototype.parseValueRadioButton = function (value) {
        return value && value.length > 0 ? value[0] : null;
    };
    ProfileContactEditionComponent.prototype.parseCityValue = function (value) {
        if (!value.city || value.city.trim() === '') {
            return null;
        }
        this.cityList.push({ id: value.city, itemName: value.cityDescription, province: value.province });
        return [{ id: value.city, itemName: value.cityDescription }];
    };
    return ProfileContactEditionComponent;
}());
export { ProfileContactEditionComponent };
